import Swal from 'sweetalert2';
import Vue from 'vue';

export async function Confirm (title, text, html = null, containerClass = 'container-swal2') {

  const vue = new Vue();

  const confirm = await Swal.fire({
    icon: text ? 'warning' : 'question',
    title: title,
    text,
    html,
    width: 350,
    buttonsStyling: false,
    allowEscapeKey: false,
    allowOutsideClick: false,
    confirmButtonColor: 'transparent',
    confirmButtonText: vue.__('Continuar'),
    cancelButtonColor: 'transparent',
    cancelButtonText: vue.__('Cancelar'),
    showCancelButton: true,
    customClass: {
      container: containerClass,
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
    },
  });

  return confirm.value === true;
}
